import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenAppLog } from '../models/open-app/open-app-log.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmOpenAppLogService extends RequestService<OpenAppLog> {
  static PATH = '/om/open/app/log';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmOpenAppLogService.PATH, globalService.debugUrl);
  }
}
